import React from "react";
import { Group } from "@mantine/core";
import CustomSearchBar from "../../ui/CustomSearchBar/CustomSearchBar";
import CustomSelect from "../../ui/CustomSelect/CustomSelect";
import CustomDateRangePicker from "../../ui/CustomDateRangePicker/CustomDateRangePicker";
import CustomExportButton from "../../ui/CustomExportButton/CustomExportButton";
import { SERVICE_CODE_OPTIONS } from "../constants/transactionConstants";
import { optionsFilterByLabel } from "../../../utils/optionsFilter";
import { parseDateRange } from "../utils/transactionFormatters";

const TransactionFilters = ({
  filters,
  merchants,
  exportProps,
  isSuperAdmin,
}) => {
  const {
    setSearchQuery,
    dateRange,
    setDateRange,
    serviceFilter,
    setServiceFilter,

    merchantId,
    setMerchantId,
  } = filters;

  const { merchantOptions, merchantOptionsLoading, isMerchantOptionsError } =
    merchants;
  const { handleExportPdf, handleExportExcel, isExporting } = exportProps;

  return (
    <Group align="flex-start" justify="start" className="mb-6">
      <CustomSearchBar
        placeholder="Search By GateWay or MerchantRef"
        onSearchChange={setSearchQuery}
        debounceDelay={600}
        size="sm"
        inputStyle={{
          width: "clamp(200px, 60vw, 400px)",
          flex: "1 1 auto",
          minWidth: 120,
        }}
        style={{ flex: "1 1 auto" }}
      />

      <CustomDateRangePicker
        value={parseDateRange(dateRange)}
        onChange={setDateRange}
        size="sm"
      />

      <CustomSelect
        data={SERVICE_CODE_OPTIONS}
        value={serviceFilter}
        searchable
        comboboxProps={{ withinPortal: false }}
        onChange={(v) => setServiceFilter(v || "all")}
        filter={optionsFilterByLabel}
        placeholder="Transaction Type"
        size="sm"
        style={{ width: 140 }}
      />
      {isSuperAdmin && (
        <CustomSelect
          data={[
            { value: "", label: "All Merchants" },
            ...(merchantOptions || []),
          ]}
          title={
            isMerchantOptionsError
              ? "Cannot Select: Failed to load merchants"
              : !merchantOptionsLoading &&
                  (!merchantOptions || merchantOptions.length === 0)
                ? "Cannot Select: No merchants available"
                : ""
          }
          value={merchantId}
          onChange={(v) => setMerchantId(v || "")}
          searchable
          comboboxProps={{ withinPortal: false }}
          placeholder="All Merchants"
          filter={optionsFilterByLabel}
          size="sm"
          style={{ width: 220 }}
          disabled={
            merchantOptionsLoading ||
            isMerchantOptionsError ||
            !(merchantOptions && merchantOptions.length > 0)
          }
        />
      )}

      <CustomExportButton
        label={isExporting ? "Exporting" : "Export"}
        filename="transactions"
        showLoadingOverlay={false}
        disabled={isExporting}
        customExportHandlers={{
          pdf: handleExportPdf,
          excel: handleExportExcel,
          csv: () => {},
        }}
        exportConfig={{
          csv: { disabled: true },
        }}
      />
    </Group>
  );
};

export default TransactionFilters;
